import React from "react"
import styled from "styled-components"

import Label from "./Label"
import ErrorText from "./ErrorText"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`

const InputContainer = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => (direction === "row" ? "row" : "column")};
`

const LabelContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.avenirNextDemi};
  line-height: 21px;
`

const InputItemWrapper = ({
  id,
  label,
  error = false,
  children,
  errorPosition = "bottom",
  direction = "column",
}) => (
  <Wrapper>
    <LabelContainer>
      <Label htmlFor={id || label}>{label}</Label>
    </LabelContainer>

    <div>
      {errorPosition === "top" && <ErrorText error={error} />}

      <InputContainer direction={direction}>{children}</InputContainer>

      {errorPosition === "bottom" && <ErrorText error={error} />}
    </div>
  </Wrapper>
)

export default InputItemWrapper
